export interface ApplyOcrFieldsResult<T> {
  next: T;
  filled: string[];
}

function isEmptyValue(value: unknown): boolean {
  return value == null || (typeof value === "string" && value.trim() === "");
}

export function applyOcrFields<T extends Record<string, string>>(
  current: T,
  fields: Record<string, string>,
  keys: (keyof T & string)[],
): ApplyOcrFieldsResult<T> {
  const next: T = { ...current };
  const filled: string[] = [];
  for (const key of keys) {
    const incoming = fields[key];
    if (isEmptyValue(current[key]) && incoming != null && incoming.trim() !== "") {
      next[key] = incoming as T[typeof key];
      filled.push(key);
    }
  }
  return { next, filled };
}
